import React, { useEffect, useState } from 'react';

import BackBtn from '../../../components/UI/BackBtn';
import { Tab, Tabs } from '../../../components/Tabs';
import useUserContext from '../../../hooks/useUserContext';
import useAPI from '../../../hooks/useAPI';

import TabDescription from './Tabs/Description';
import TabTeam from '../../../components/strategyProject/tabs/TabTeam';
import TabIndex from './Tabs/Index';
import TabProjectRegister from './Tabs/ProjectRegister';
import useNavProject from '../../../hooks/useNavProject';
import ButtonsCard from '../PassportRead/ButtonsCard';

export default function PortfolioProfilePage({ portfolioId }) {
  const userCtx = useUserContext();
  const api = useAPI();
  const navProject = useNavProject();

  const [portfolio, setPortfolio] = useState(null);

  useEffect(async () => {
    const resp = await api.get(`/portfolios/${portfolioId}?readonly=true`);

    if (resp && !resp.error) setPortfolio({ ...resp, users: resp.users.map((u) => ({ ...u, ...u.user })) });
  }, []);

  useEffect(async () => {
    const resp = await api.get(`/structure/portfolios/${portfolioId}`);
    if (resp && !resp.error) {
      const strategyName = resp.strategy.name;
      navProject.setPortfolioTitle(resp.name);
      resp.strategy.type === 'strategy' ? navProject.setStratTitle(strategyName) : navProject.setPolicyTitle(strategyName);
    }
  }, []);

  const tabs = [
    { label: 'description', tabName: 'Общая информация', content: <TabDescription data={portfolio} /> },
    { label: 'team', tabName: 'Команда управления', content: <TabTeam data={portfolio} /> },
    { label: 'index', tabName: 'Показатели', content: <TabIndex data={portfolio} /> },
    { label: 'subprojectconnection', tabName: 'Реестр проектов ', content: <TabProjectRegister data={portfolio} /> },
  ];

  return (
    <section className="page">
      <div className="container">
        <BackBtn />
        {portfolio && (
        <section className="page project-page">
          <div className="project-title-wrapper">
            <h3>
              Портфель "
              {portfolio.name}
              "
            </h3>
          </div>
          <Tabs>
            {tabs
              .filter((tab) => !tab.hide || !tab.hide(userCtx.perms))
              .map((tab, i) => (
                <Tab key={i} label={tab.label} tabName={tab.tabName}>
                  {tab.content}
                </Tab>
              ))}
          </Tabs>
          <ButtonsCard
            portfId={portfolio.id}
          />
        </section>
        )}
      </div>
    </section>
  );
}
